/* AIRFORGE — interacciones (vanilla, sin librerías) */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveals(root) {
    var els = (root || document).querySelectorAll('.af-reveal, .af-observe');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('af-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('af-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function initParallax() {
    var els = document.querySelectorAll('[data-af-parallax]');
    if (!els.length || reduce) return;
    var ticking = false;
    function update() {
      var vh = window.innerHeight;
      els.forEach(function (el) {
        var r = el.parentElement.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        var k = parseFloat(el.getAttribute('data-af-parallax')) || 0;
        var p = (r.top + r.height / 2 - vh / 2) / vh;
        el.style.transform = 'translate3d(0,' + (p * k * -1).toFixed(1) + 'px,0)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    update();
  }

  function initSteps() {
    document.querySelectorAll('.af-steps').forEach(function (sec) {
      var steps = sec.querySelectorAll('.af-step');
      var imgs = sec.querySelectorAll('.af-steps__stage img');
      var cur = sec.querySelector('.af-steps__cur');
      var bar = sec.querySelector('.af-steps__bar i');
      if (!steps.length) return;
      function activate(i) {
        steps.forEach(function (s, j) { s.classList.toggle('is-active', j === i); });
        imgs.forEach(function (im, j) { im.classList.toggle('is-active', j === i); });
        if (cur) cur.textContent = String(i + 1).padStart(2, '0');
        if (bar) bar.style.setProperty('--af-p', (i + 1) / steps.length);
      }
      activate(0);
      if (!('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) activate(Array.prototype.indexOf.call(steps, e.target));
        });
      }, { rootMargin: '-45% 0px -45% 0px' });
      steps.forEach(function (s) { io.observe(s); });
    });
  }

  function initRail() {
    document.querySelectorAll('.af-sports').forEach(function (sec) {
      var rail = sec.querySelector('.af-sports__rail');
      if (!rail) return;
      function step() { var c = rail.querySelector('.af-sport'); return c ? c.getBoundingClientRect().width + 18 : 300; }
      var prev = sec.querySelector('[data-af-prev]'), next = sec.querySelector('[data-af-next]');
      if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: 'smooth' }); });
      var down = false, sx = 0, sl = 0, moved = false;
      rail.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse') return; down = true; moved = false; sx = e.clientX; sl = rail.scrollLeft; });
      window.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - sx;
        if (Math.abs(dx) > 4) { moved = true; rail.classList.add('is-drag'); }
        rail.scrollLeft = sl - dx;
      });
      window.addEventListener('pointerup', function () { down = false; rail.classList.remove('is-drag'); });
      rail.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
    });
  }

  function initColors() {
    document.querySelectorAll('.af-colors').forEach(function (sec) {
      var sw = sec.querySelectorAll('.af-swatch');
      var imgs = sec.querySelectorAll('.af-colors__stage img');
      var word = sec.querySelector('.af-colors__word');
      var glow = sec.querySelector('.af-colors__glow');
      if (!sw.length) return;
      var idx = 0, timer = null;
      var auto = parseInt(sec.getAttribute('data-af-auto'), 10) || 0;
      function go(i) {
        idx = i;
        sw.forEach(function (s, j) { s.classList.toggle('is-active', j === i); s.setAttribute('aria-pressed', j === i); });
        imgs.forEach(function (im, j) { im.classList.toggle('is-active', j === i); });
        if (word) word.textContent = sw[i].getAttribute('data-word') || '';
        if (glow) glow.style.setProperty('--af-glow', sw[i].getAttribute('data-glow'));
      }
      function loop() { if (auto && !reduce) { clearInterval(timer); timer = setInterval(function () { go((idx + 1) % sw.length); }, auto * 1000); } }
      sw.forEach(function (s, j) { s.addEventListener('click', function () { go(j); loop(); }); });
      go(0); loop();
    });
  }

  function initGallery() {
    document.querySelectorAll('.af-gal').forEach(function (g) {
      var imgs = g.querySelectorAll('.af-gal__main img');
      var th = g.querySelectorAll('.af-gal__thumb');
      if (imgs.length < 2) return;
      var i = 0;
      function go(n) {
        i = (n + imgs.length) % imgs.length;
        imgs.forEach(function (im, j) { im.classList.toggle('is-active', j === i); });
        th.forEach(function (t, j) { t.classList.toggle('is-active', j === i); });
        if (th[i]) th[i].scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
      }
      th.forEach(function (t, j) { t.addEventListener('click', function () { go(j); }); });
      var p = g.querySelector('[data-af-gprev]'), n = g.querySelector('[data-af-gnext]');
      if (p) p.addEventListener('click', function () { go(i - 1); });
      if (n) n.addEventListener('click', function () { go(i + 1); });
      var main = g.querySelector('.af-gal__main'), x0 = null;
      main.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      main.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) go(i + (dx < 0 ? 1 : -1));
        x0 = null;
      });
    });
  }

  function initBuy() {
    document.querySelectorAll('.af-pdp').forEach(function (sec) {
      var form = sec.querySelector('form[action*="/cart/add"]');
      if (!form) return;
      var qty = form.querySelector('.af-qty input');
      form.querySelectorAll('.af-qty button').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = parseInt(qty.value, 10) || 1;
          qty.value = Math.max(1, v + (b.hasAttribute('data-plus') ? 1 : -1));
        });
      });
      var bundle = sec.querySelector('[data-af-bundle]');
      if (bundle && qty) {
        bundle.addEventListener('change', function (e) {
          if (e.target.name === 'af-bundle') qty.value = e.target.value;
        });
      }
      var dataEl = sec.querySelector('[data-af-variants]');
      var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
      var idInput = form.querySelector('input[name="id"]');
      var btn = form.querySelector('[name="add"]');
      var btnLabel = btn ? btn.querySelector('.af-btn__label') : null;
      var priceNow = sec.querySelector('.af-buy__price .now');
      var priceWas = sec.querySelector('.af-buy__price .was');
      var fmt = sec.getAttribute('data-money') || '{{amount}}';
      function money(c) {
        var a = (c / 100).toFixed(2);
        return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
          if (k.indexOf('no_decimals') > -1) a = Math.round(c / 100).toString();
          if (k.indexOf('comma') > -1) a = a.replace('.', ',');
          return a.replace(/\B(?=(\d{3})+(?!\d))/g, k.indexOf('comma') > -1 ? '.' : ',');
        });
      }
      sec.querySelectorAll('.af-opt input').forEach(function (inp) {
        inp.addEventListener('change', function () {
          var sel = [];
          sec.querySelectorAll('.af-opt').forEach(function (fs) { var c = fs.querySelector('input:checked'); sel.push(c ? c.value : null); });
          var v = variants.find(function (x) { return x.options.every(function (o, k) { return o === sel[k]; }); });
          if (!v) return;
          idInput.value = v.id;
          if (priceNow) priceNow.textContent = money(v.price);
          if (priceWas) { priceWas.textContent = v.compare_at_price > v.price ? money(v.compare_at_price) : ''; }
          if (btn) { btn.disabled = !v.available; if (btnLabel) btnLabel.textContent = v.available ? btn.getAttribute('data-on') : btn.getAttribute('data-off'); }
          if (v.featured_media) {
            var t = sec.querySelector('.af-gal__thumb[data-media="' + v.featured_media.id + '"]');
            if (t) t.click();
          }
        });
      });
      var bar = document.querySelector('.af-sticky-buy');
      if (bar && btn && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (en) { bar.classList.toggle('is-on', !en[0].isIntersecting && en[0].boundingClientRect.top < 0); }).observe(btn);
        bar.querySelector('button').addEventListener('click', function () { btn.click(); });
      }
    });
  }

  function initCounters(root) {
    (root || document).querySelectorAll('[data-af-count]').forEach(function (el) {
      var target = parseInt(el.getAttribute('data-af-count'), 10) || 0;
      var fmt = function (n) { return Math.round(n).toLocaleString('en-US'); };
      if (reduce || !('IntersectionObserver' in window)) { el.textContent = fmt(target); return; }
      el.textContent = fmt(0);
      var io = new IntersectionObserver(function (en) {
        if (!en[0].isIntersecting) return;
        io.disconnect();
        var t0 = null, dur = 1800;
        function step(t) {
          if (!t0) t0 = t;
          var k = Math.min(1, (t - t0) / dur);
          el.textContent = fmt(target * (1 - Math.pow(1 - k, 3)));
          if (k < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      }, { threshold: 0.4 });
      io.observe(el);
    });
  }

  function initAll() { initCounters(); initReveals(); initParallax(); initSteps(); initRail(); initColors(); initGallery(); initBuy(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', function (e) { initReveals(e.target); initSteps(); initRail(); initColors(); initGallery(); });
})();
